// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-21T22:00:30.157Z
// Property: Serafina (ID: 6767906449166451)
// Collections: 22 amenities, 20 floorplans (live), 24 photos, 50 POIs, 5 reviews, 3 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166451",
  "property_external_id": "rmdwbk1",
  "property_zillow_url": "https://www.zillow.com/apartments/goodyear-az/serafina-apartment-homes/5ZG3Gp/",
  "property_apartments_url": "https://www.apartments.com/serafina-apartments-goodyear-az/rmdwbk1/",
  "property_google_business_url": "https://www.google.com/maps/place/Serafina+Apartments/data=!4m2!3m1!1s0x0:0x4927df5a80e824ca?sa=X&ved=2ahUKEwigr82-5KeSAxUrr1YBHaS6HTkQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40246265944",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "226SRF",
  "property_status": null,
  "property_slug": "serafina",
  "property_name": "Serafina",
  "property_website_url": "http://www.serafinaliving.com/",
  "property_domain": "https://www.serafinaliving.com/",
  "property_address": "15400 West Goodyear Boulevard North",
  "property_full_address": "15400 W Goodyear Blvd N, Goodyear, AZ 85338",
  "property_address_1": "15400 W Goodyear Blvd N",
  "property_address_2": null,
  "property_address_city": "Goodyear",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85338",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "Canyon Trails",
  "property_address_latitude": "33.440519",
  "property_address_longitude": "-112.3907758",
  "property_email": null,
  "property_phone": "(855) 449-9119",
  "property_call_tracking_phone": "844-888-2412",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Serafina in Goodyear, AZ, luxury meets comfort in our spacious one, two, and three-bedroom apartments. Enjoy endless amenities including a pool, fitness center, and inviting clubhouse, all designed with your lifestyle in mind. Embrace community living and make Serafina your sanctuary—schedule a tour today!",
  "property_long_description": "Welcome to Serafina, your premier apartment community nestled in the vibrant heart of Goodyear, AZ. Our beautifully designed floor plans offer a variety of options tailored to fit your lifestyle, including spacious one, two, and three-bedroom layouts that maximize comfort and style. Enjoy delightful amenities that enhance your everyday living, from our sparkling swimming pool and relaxing hot tub to a fully equipped fitness center that makes staying active easy and convenient.\n\nAt Serafina, we prioritize your convenience and community experience. Our clubhouse and picnic area are perfect for social gatherings, while the on-site business center supports your professional needs. Families will appreciate our playground and planned social activities that foster a sense of belonging. Enjoy the ease of community-wide WiFi, door-to-door trash pickup, and a reliable maintenance team available on site.\n\nEach apartment home features modern amenities, including high-speed internet access, washer and dryer units, and stainless steel appliances. Enjoy spacious layouts accented with crown molding, vaulted ceilings, and windows that invite in ample natural light. Relax on your private balcony or patio, or take advantage of nearby public transportation for easy commuting.\n\nDiscover a lifestyle that combines comfort, convenience, and community at Serafina. With on-site retail options and the beauty of Goodyear just outside your door, every day feels like a retreat. \n\nDon’t wait—find your new home today! Browse our availability or schedule a tour to explore all that Serafina has to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019f6b9b-82fc-7073-bfd4-acb166354dbd.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with waterfall feature and palm trees.",
    "public_id": "019f6b9b-82fc-7073-bfd4-acb166354dbd",
    "storage_key": "property/6767906449166451/019f6b9b-82fc-7073-bfd4-acb166354dbd.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166451/019ffc3b-899c-75ac-8998-429f8a8edd1e.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc3b-899c-75ac-8998-429f8a8edd1e",
    "storage_key": "property/6767906449166451/019ffc3b-899c-75ac-8998-429f8a8edd1e.m4v",
    "thumbnail_key": "property/6767906449166451/019ffc3b-899c-75ac-8998-429f8a8edd1e_thumb.webp",
    "size_bytes": 18629109,
    "classification": "Community",
    "title": "Discover Luxury Living: Amenities and Interiors",
    "description": "Explore the premium amenities, including BBQ grills and a game area, alongside beautifully appointed apartment interiors with modern kitchens and dining spaces."
  },
  "property_total_units": "268",
  "property_year_built": "2008",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.16417910447761",
  "property_admin_fee": "300.00",
  "property_application_fee": "65.00",
  "property_fees_deposit_info": "Security Deposit\n$300 - 1 Month's Rent (refundable)",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "45",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum of 2 pets per unit.",
  "property_pet_policy_description": "Cats and dogs allowed. One-Time Pet Fee: $350 per pet. Monthly pet rent: $45 per pet. Maximum of 2 pets per unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://serafina.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amcserafina",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02ce-99c2-719b-992d-97503b00a2cd.webp",
  "property_primary_logo_media": {
    "alt_text": "Serafina Luxury Apartments logo",
    "public_id": "019d02ce-99c2-719b-992d-97503b00a2cd",
    "storage_key": "property/6767906449166451/019d02ce-99c2-719b-992d-97503b00a2cd.webp",
    "width": 336,
    "height": 95
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02ce-a361-758d-bc3b-943e0be17552.webp",
  "property_secondary_logo_media": {
    "alt_text": "Serafina Luxury Apartments logo",
    "public_id": "019d02ce-a361-758d-bc3b-943e0be17552",
    "storage_key": "property/6767906449166451/019d02ce-a361-758d-bc3b-943e0be17552.webp",
    "width": 336,
    "height": 95
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02ce-aea4-74c4-93b9-42fba964c660.webp",
  "property_icon_media": {
    "alt_text": "Placeholder image with the letter S",
    "public_id": "019d02ce-aea4-74c4-93b9-42fba964c660",
    "storage_key": "property/6767906449166451/019d02ce-aea4-74c4-93b9-42fba964c660.webp",
    "width": 32,
    "height": 32
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02ce-aea4-74c4-93b9-42fba964c660.webp",
  "property_fav_icon_media": {
    "alt_text": "Placeholder image with the letter S",
    "public_id": "019d02ce-aea4-74c4-93b9-42fba964c660",
    "storage_key": "property/6767906449166451/019d02ce-aea4-74c4-93b9-42fba964c660.webp",
    "width": 32,
    "height": 32
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02ce-c8c5-72aa-953f-cfe3f4eb1d8e.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Serafina Luxury Apartments logo",
    "public_id": "019d02ce-c8c5-72aa-953f-cfe3f4eb1d8e",
    "storage_key": "property/6767906449166451/019d02ce-c8c5-72aa-953f-cfe3f4eb1d8e.webp",
    "width": 336,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02ce-99c2-719b-992d-97503b00a2cd.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Serafina Luxury Apartments logo",
    "public_id": "019d02ce-99c2-719b-992d-97503b00a2cd",
    "storage_key": "property/6767906449166451/019d02ce-99c2-719b-992d-97503b00a2cd.webp",
    "width": 336,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "745 - 1359",
  "property_sqft_min": "745",
  "property_sqft_max": "1359",
  "property_price_range": null,
  "property_price_min": "1264",
  "property_price_max": null,
  "property_available_units": 21,
  "property_facebook_url": "https://www.facebook.com/SerafinaApartments",
  "property_instagram_url": "https://www.instagram.com/serafinaapts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJK5tj8Vo4K4cRyiTogFrfJ0k",
  "property_youtube_url": "https://www.youtube.com/watch?v=tTOux4K-tw8#:~:text=great%20family%2Dfriendly%20options%20for%20entertainment%20and%20a,in%20the%20Phoenix%20area!%20I%20have%20work",
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Apartment+Complex&find_loc=Goodyear%2C+AZ",
  "property_tiktok_url": "https://www.tiktok.com/discover/serafina-apartments-goodyear",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Serafina",
  "property_home_romance_title": "Find Your Forever Home in Our Cherished Community",
  "property_home_amenities_blurb": "At Serafina in Goodyear, AZ, your dream lifestyle awaits. Choose from spacious one, two, or three-bedroom apartments, each designed for comfort and convenience. Enjoy amenities like a sparkling pool, fitness center, and inviting clubhouse, all while surrounded by lush courtyards and a vibrant community. Experience modern living today!",
  "property_home_floorplans_blurb": "Welcome to Serafina in Goodyear, AZ, where comfort meets contemporary design. With thoughtfully crafted one, two, and three-bedroom floor plans, your ideal living space awaits. Embrace a lifestyle filled with modern amenities and vibrant community vibes—browse our available apartment homes today and find your perfect match!",
  "property_home_gallery_blurb": "At Serafina in Goodyear, AZ, your dream lifestyle awaits in dynamic one, two, and three-bedroom layouts. Enjoy the perfect blend of relaxation and recreation with amenities like a sparkling pool, fitness center, and vibrant community events. Picture yourself living here, where comfort meets convenience in every corner.",
  "property_home_neighborhood_blurb": "Welcome to Serafina, your Goodyear oasis! Choose from our thoughtfully designed one, two, or three-bedroom floor plans, and embrace the vibrant local scene. Just steps away, enjoy greenery at Friendship Park, thrill-seeking at Urban Air Trampoline Park, or a round of golf at Wigwam Golf Club. Your ideal lifestyle awaits!",
  "property_home_reviews_blurb": "At Serafina in Goodyear, AZ, residents thrive in a warm, welcoming community where friendly staff and responsive maintenance make every day enjoyable. Experience the spacious, modern apartments, lovely pools, and well-kept grounds that feel like a resort. As one resident shared, “We are just very happy to be here.”",
  "property_neighborhood_blurb": "Step outside Serafina in Goodyear, AZ, and embrace a vibrant community rich in activities, from the thrill of Urban Air Trampoline Park to the serenity of Friendship Park. With nearby Estrella Mountain Community College and the enriching PW Litchfield Heritage Center, explore the perfect balance of excitement and tranquility right at your doorstep.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Serafina in sunny Goodyear, AZ, where modern living meets comfort and convenience. Choose from spacious one, two, or three-bedroom apartments, each designed to enhance your lifestyle. Dive into our resort-style pool, unwind in the hot tub, or connect with neighbors at the clubhouse—your perfect oasis awaits!",
  "property_applynow_blurb": "At Serafina in Goodyear, AZ, your ideal living space awaits with spacious one to three-bedroom floor plans. Enjoy resort-style amenities like a refreshing pool, state-of-the-art fitness center, and a vibrant clubhouse. Embrace a lifestyle rich in comfort and convenience—apply today and elevate your living experience!",
  "property_contactus_blurb": "At Serafina in Goodyear, AZ, our thoughtfully designed floor plans cater to every lifestyle, featuring one, two, and three-bedroom options. Experience a harmonious blend of comfort and style in your next home. Need assistance? Reach out to our leasing team today for personalized support!",
  "property_faqs_blurb": "Welcome to Serafina, where your ideal home awaits in the heart of Goodyear, AZ. Whether you're searching for a cozy one-bedroom retreat or a spacious three-bedroom layout, we have the perfect floor plan for you. Curious about our community? Browse our FAQs page for insights and answers!",
  "property_floorplans_blurb": "At Serafina in Goodyear, AZ, our diverse floor plans cater to every lifestyle. Whether you're searching for a cozy one-bedroom retreat, a spacious two-bedroom haven, or a luxurious three-bedroom escape, each layout blends comfort and elegance. Browse our available apartment homes and find the perfect fit just for you.",
  "property_gallery_blurb": "At Serafina in Goodyear, AZ, we weave comfort and style into every detail, from spacious one to three-bedroom floor plans to exceptional amenities. Imagine lazy afternoons by the pool, energizing workouts in the fitness center, and vibrant community events. Picture yourself living here, where every moment feels extraordinary!",
  "property_interactivemap_blurb": "At Serafina in Goodyear, AZ, each apartment combines comfort and style with spacious floor plans—from cozy one-bedrooms to luxurious three-bedrooms. With amenities like a sparkling pool, fitness center, and vibrant community spaces, your perfect home awaits. Use our interactive map to find your ideal living space today!",
  "property_pets_blurb": "At Serafina in Goodyear, AZ, your furry friends are part of the family! Our community welcomes both cats and dogs, with spacious apartments designed for comfortable living. With tailored pet fees and a maximum of two pets, you’ll find the perfect space for you and your companions.",
  "property_referafriend_blurb": "At Serafina in Goodyear, AZ, our spacious one, two, and three-bedroom floor plans offer the perfect backdrop for lasting memories. Share the joy of living in our vibrant community – refer a friend today and embrace the beauty of great friendships right at your doorstep!",
  "property_residentaccess_blurb": "Welcome to Serafina in sunny Goodyear, AZ, where your ideal home awaits! Choose from our thoughtfully designed one, two, or three-bedroom floor plans that perfectly suit your lifestyle. Log in to the resident portal for seamless rent payments, maintenance requests, and exclusive community updates. Your comfort is just a click away!",
  "property_reviews_blurb": "At Serafina in Goodyear, AZ, residents rave about the community's inviting atmosphere and responsive management, saying, “I have really enjoyed living in this complex. Management staff is friendly and responsive.\" With spacious apartments, well-kept grounds, and a pool that feels like a retreat, you'll feel right at home. ",
  "property_created_at": "1759782590320",
  "property_scheduletour_blurb": "At Serafina in Goodyear, AZ, you’ll find thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Experience a vibrant community atmosphere while enjoying unique amenities that elevate everyday living. Curious about our residents' experiences? Come see for yourself—schedule a tour today!",
  "property_thankyou_blurb": "Thank you for your interest in Serafina, where stylish living meets comfort in Goodyear, AZ. Whether you're looking for a one, two, or three-bedroom apartment, our diverse floor plans cater to your unique lifestyle. A team member will reach out soon to help you find your perfect home!",
  "property_virtualtours_blurb": "Step into Serafina in Goodyear, AZ, where spacious one to three-bedroom apartments invite you to embrace a vibrant lifestyle. Wander through our virtual tour and envision your new home, complete with modern designs and amenities that elevate everyday living. Your dream apartment awaits—join us today!",
  "property_copyright": "2025 All Rights Reserved. Serafina",
  "property_seo_title_home": "Serafina |  Apartments in Goodyear, AZ",
  "property_seo_description_home": "Unwind at Serafina in Goodyear, AZ. Spacious one to three-bedroom apartments with resort-style amenities. Your perfect home awaits—join our vibrant community!",
  "property_seo_title_floorplans": "Floor Plans | Goodyear, AZ Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect fit at Serafina in Goodyear, AZ! Choose from one, two, or three-bedroom floor plans tailored to your lifestyle. Browse now!",
  "property_seo_title_amenities": "Amenities | Goodyear, AZ Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Serafina in Goodyear, AZ! Enjoy spacious floor plans, a refreshing pool, fitness center, and more. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Goodyear, AZ",
  "property_seo_description_gallery": "Find your oasis at Serafina in Goodyear, AZ! With stunning floor plans, luxurious amenities, and vibrant community spaces, it’s time to picture your new home!",
  "property_seo_title_virtualtours": "Resident Access | Apartments in Goodyear, AZ",
  "property_seo_description_virtualtours": "Access your resident portal at Serafina in Goodyear, AZ. Easily pay rent, submit maintenance requests, and stay connected to your community.",
  "property_seo_title_interactivemap": "Interactive Map | Homes For Rent In Goodyear, AZ",
  "property_seo_description_interactivemap": "Uncover your perfect home at Serafina in Goodyear, AZ! Use our interactive map to browse one to three-bedroom apartments and find your ideal space today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Goodyear, AZ",
  "property_seo_description_neighborhood": "Experience the vibrant Goodyear community at Serafina! Uncover nearby favorites, local gems, and exciting points of interest just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Apartments Near Phoenix, AZ",
  "property_seo_description_contact": "Reach out to Serafina in Goodyear, AZ! Whether for one, two, or three-bedroom apartments, our leasing team is ready to assist you. Connect with us!",
  "property_seo_title_faqs": "FAQs | Apartments in Goodyear, AZ",
  "property_seo_description_faqs": "Got questions? Our Serafina community FAQ page in Goodyear, AZ, has all the answers! Learn about our amenities, floor plans, and lifestyle that awaits you!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Goodyear, AZ",
  "property_seo_description_reviews": "Join the vibrant Serafina community in Goodyear, AZ! See why residents love our spacious floor plans, top-notch amenities, and engaging social activities.",
  "property_seo_title_applynow": "Apply Now | Apartments in Goodyear, AZ",
  "property_seo_description_applynow": "Live your best life at Serafina in Goodyear, AZ! Enjoy resort-style amenities, stylish floor plans, and a vibrant community. Find your perfect home today!",
  "property_seo_title_residentaccess": "Apply Now | Apartments in Goodyear, AZ For Rent",
  "property_seo_description_residentaccess": "Apply online today at Serafina Apartments in Goodyear, AZ. Start your application and find your next home near Phoenix.",
  "property_seo_title_referafriend": "Refer A Friend | Serafina",
  "property_seo_description_referafriend": "Refer a friend to Serafina in Goodyear, AZ! Great friends make fantastic neighbors. Share the joy of our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Homes Near Tempe, AZ",
  "property_seo_description_scheduletour": "Schedule a tour of Serafina Apartments in Goodyear, AZ. Explore renovated apartment homes and a convenient North Goodyear location.",
  "property_seo_title_privacy": "Privacy Policy | Serafina",
  "property_seo_description_privacy": "At Serafina in Goodyear, AZ, your privacy matters. Learn how we protect your information while you enjoy luxury living. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Serafina",
  "property_seo_description_accessibility": "At Serafina in Goodyear, AZ, we embrace digital inclusion and accessibility. Join our welcoming community designed for all.",
  "property_seo_title_sitemap": "Sitemap | Apartments for Rent in Goodyear, AZ",
  "property_seo_description_sitemap": "Unlock the charm of Serafina in Goodyear, AZ. Dive into our sitemap for a seamless journey through our vibrant community and find your perfect home today!",
  "property_seo_title_thankyou": "Thank You | Apartments in Goodyear, AZ",
  "property_seo_description_thankyou": "Thank you for reaching out to Serafina in Goodyear, AZ! Our team will connect with you soon to help you find your perfect new home. Stay tuned!",
  "property_seo_title_pets": "Pets | Apartments in Goodyear, AZ",
  "property_seo_description_pets": "Learn more about our pet policy at Serafina in North Goodyear, AZ. Visit our Pets page, and contact our Leasing Office with any questions!",
  "property_updated_at": "1786643191936",
  "amenities": [
    {
      "id": "custom_84eabadd-4aeb-4731-9331-f194032d76d1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Resort Style Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a2b35507-da5a-4e1c-a1c9-ce283e948966",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Relaxing Spa w/ Seating",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_020dbc97-3cbb-4829-b03d-b6290430bbc0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Gas Grills",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_0cd490c5-75ec-4957-b44a-c373c9bf3c90",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Club",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f60dd2f8-21a8-4276-8f28-143a2f5c5ace",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center w/ WiFi",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_dce625bb-a5ff-45bd-9bb7-ceb49ee69613",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_19c43f4f-0e4a-4fb3-b40f-824533d202dc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_926d565f-a329-4ba2-aaf2-66b5d7af6b5d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f1c08fc0-7d5d-4ad5-844d-ddd94c4df3db",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Conveniently Located near Freeway Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_9eb82af6-01cf-44a6-bd04-a0b56d5d2fd3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Private Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_b9c66bca-d0f9-489a-8a70-1cfd0ff3176d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Covered Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_cc442a3a-27fd-49b2-a495-3baace880f77",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Newly Renovated Apartment Homes",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d34ef7cd-f844-4d5f-a77e-f57babe377a7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz Countertops*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f5a85a9a-6d33-4a33-a586-c223a13b5262",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Black Appliances w/ Ice Maker*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_93ad232b-d0f5-44cc-a976-65ccbd93b2f5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Modern Kitchen w/ Oversized Countertops*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_00f8f686-cd81-4fae-9afa-46dc6f7398dc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Cable/ Satellite Available",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7f168917-3f99-40ee-9697-5a265c4f0f18",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Large Private Patios",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_c233b8b5-2957-46c7-8b79-dfe726a3cd24",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Full size Washer and Dryers*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_89eb5fe7-50e3-43ff-bd5e-331bd21efe13",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Large Walk In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_360a4ad1-0ee2-473d-901d-cc073abeecd2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Style Plank Flooring*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_3667a3b0-900f-44ac-9445-04d79bef4c66",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Property Wide Fiber Optic Internet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a990c3f7-95f5-4277-a3d0-d366a2d7c190",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Peninsulas",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_6a00e514-b10a-49d7-a1b3-a9da5e89c608",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109d-ba04-74f6-814b-e68ce8a99d7a.webp",
      "image_media": {
        "alt_text": "Community entrance with a fountain and palm trees at Serafina in Goodyear, AZ,",
        "public_id": "01a0109d-ba04-74f6-814b-e68ce8a99d7a",
        "storage_key": "property/6767906449166451/01a0109d-ba04-74f6-814b-e68ce8a99d7a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our community entrance, featuring a beautiful fountain and lush landscaping with palm trees, leading to the leasing center.",
      "link": "",
      "alt_text": "Community entrance with a fountain and palm trees at Serafina in Goodyear, AZ,",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dfe5a62e-0216-42d4-a754-658a8915350b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-31f4-7458-8510-717778c52d2b.webp",
      "image_media": {
        "alt_text": "Fountain in front of the leasing center at Serafina Luxury Apartments.",
        "public_id": "01a0109e-31f4-7458-8510-717778c52d2b",
        "storage_key": "property/6767906449166451/01a0109e-31f4-7458-8510-717778c52d2b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Serafina Luxury Apartments, featuring an elegant fountain and a welcoming leasing center.",
      "link": "",
      "alt_text": "Fountain in front of the leasing center at Serafina Luxury Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8d057b36-ae7e-4aa5-a3c6-9dc6de4f84c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-e0bc-75d8-bbbb-a04fa5aebb14.webp",
      "image_media": {
        "alt_text": "Lobby area with seating and reception desk at Serafina in Goodyear, AZ.",
        "public_id": "01a0109e-e0bc-75d8-bbbb-a04fa5aebb14",
        "storage_key": "property/6767906449166451/01a0109e-e0bc-75d8-bbbb-a04fa5aebb14.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our spacious and modern lobby, featuring comfortable seating and a professional reception area for your convenience.",
      "link": "",
      "alt_text": "Lobby area with seating and reception desk at Serafina in Goodyear, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_22c0a3e8-5705-4bc1-8a54-46c60b98bdeb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-ccc2-73cd-b45f-4a7c5e4c9168.webp",
      "image_media": {
        "alt_text": "Modern community lounge area with bar stools and tables near large windows at Serafina in Goodyear, AZ.",
        "public_id": "01a0109e-ccc2-73cd-b45f-4a7c5e4c9168",
        "storage_key": "property/6767906449166451/01a0109e-ccc2-73cd-b45f-4a7c5e4c9168.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating and ample natural light.",
      "link": "",
      "alt_text": "Modern community lounge area with bar stools and tables near large windows at Serafina in Goodyear, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3e047e63-142e-45a2-b247-649de6510b34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-e535-73db-b982-88857dc6a945.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, weight bench, and free weights.",
        "public_id": "01a0109e-e535-73db-b982-88857dc6a945",
        "storage_key": "property/6767906449166451/01a0109e-e535-73db-b982-88857dc6a945.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines, weight training equipment, and free weights.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, weight bench, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8330a17d-56f4-43da-81d6-1fd3e7633a55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-7da0-722f-83e1-357efa1873eb.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, weight bench, and dumbbells.",
        "public_id": "01a0109e-7da0-722f-83e1-357efa1873eb",
        "storage_key": "property/6767906449166451/01a0109e-7da0-722f-83e1-357efa1873eb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, free weights, and a weight bench for a complete workout experience.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, weight bench, and dumbbells.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5bef5ca5-2655-4f71-9bf5-54ac81f1c137",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-e697-779a-86cf-42642c7a2383.webp",
      "image_media": {
        "alt_text": "Billiards room with a pool table and bar seating at Serafina in Goodyear, AZ.",
        "public_id": "01a0109e-e697-779a-86cf-42642c7a2383",
        "storage_key": "property/6767906449166451/01a0109e-e697-779a-86cf-42642c7a2383.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a game of pool in our community's billiards room, complete with a full-size table and bar seating for socializing.",
      "link": "",
      "alt_text": "Billiards room with a pool table and bar seating at Serafina in Goodyear, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0bc80d47-40fa-40a9-b012-8c7ed091e3f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-bf50-74bb-a8a8-e50a557dae65.webp",
      "image_media": {
        "alt_text": "Ping pong table with paddles and ball outside a building with open doors revealing a bar area.",
        "public_id": "01a0109e-bf50-74bb-a8a8-e50a557dae65",
        "storage_key": "property/6767906449166451/01a0109e-bf50-74bb-a8a8-e50a557dae65.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a game of ping pong or relax at the bar in this community's vibrant social area.",
      "link": "",
      "alt_text": "Ping pong table with paddles and ball outside a building with open doors revealing a bar area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_226fe4bc-b51f-4ae5-befb-ef5a9c71803a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-e4fc-7178-a72c-a0007d6cb947.webp",
      "image_media": {
        "alt_text": "Outdoor patio with wicker furniture and a fireplace.",
        "public_id": "01a0109e-e4fc-7178-a72c-a0007d6cb947",
        "storage_key": "property/6767906449166451/01a0109e-e4fc-7178-a72c-a0007d6cb947.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors on this spacious patio, complete with comfortable wicker seating and a cozy fireplace for cooler evenings.",
      "link": "",
      "alt_text": "Outdoor patio with wicker furniture and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_11947a47-e660-4b42-8615-c0904605383b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-b62c-748e-b411-c5316e64df69.webp",
      "image_media": {
        "alt_text": "Curving swimming pool with palm trees and apartment buildings in the background at Serafina in Goodyear, AZ.",
        "public_id": "01a0109e-b62c-748e-b411-c5316e64df69",
        "storage_key": "property/6767906449166451/01a0109e-b62c-748e-b411-c5316e64df69.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling swimming pool, surrounded by lush palm trees and modern apartment buildings. The perfect oasis for relaxation and fun.",
      "link": "",
      "alt_text": "Curving swimming pool with palm trees and apartment buildings in the background at Serafina in Goodyear, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6016ebe5-104f-458e-abc3-8a68f0693c60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-905f-750f-926e-a0651f8ad5a4.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex swimming pool with palm trees and lounge chairs at Serafina in Goodyear, AZ.",
        "public_id": "01a0109e-905f-750f-926e-a0651f8ad5a4",
        "storage_key": "property/6767906449166451/01a0109e-905f-750f-926e-a0651f8ad5a4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning swimming pool, surrounded by lush palm trees and comfortable lounge chairs. Perfect for soaking up the sun and enjoying the resort-style amenities.",
      "link": "",
      "alt_text": "Luxury apartment complex swimming pool with palm trees and lounge chairs at Serafina in Goodyear, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_44fe66ad-3d82-477a-8708-831a6a4fe1c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109d-b86a-706c-851e-0887f7c6753d.webp",
      "image_media": {
        "alt_text": "Resort-style pool and spa area with palm trees and lounge seating at Serafina in Goodyear, AZ.",
        "public_id": "01a0109d-b86a-706c-851e-0887f7c6753d",
        "storage_key": "property/6767906449166451/01a0109d-b86a-706c-851e-0887f7c6753d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our sparkling resort-style swimming pool and spa, perfect for relaxing or entertaining, surrounded by lush palm trees and comfortable lounge seating.",
      "link": "",
      "alt_text": "Resort-style pool and spa area with palm trees and lounge seating at Serafina in Goodyear, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ceef57d1-a984-410d-9e3f-2bcdc15677a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-ac68-70e4-8e31-5d04950c6c73.webp",
      "image_media": {
        "alt_text": "Outdoor spa with lounge chairs and surrounding apartment buildings at Serafina in Goodyear, AZ.",
        "public_id": "01a0109e-ac68-70e4-8e31-5d04950c6c73",
        "storage_key": "property/6767906449166451/01a0109e-ac68-70e4-8e31-5d04950c6c73.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our community's inviting outdoor spa, featuring comfortable lounge chairs and a tranquil atmosphere.",
      "link": "",
      "alt_text": "Outdoor spa with lounge chairs and surrounding apartment buildings at Serafina in Goodyear, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5982cd82-12ce-45f6-b2b1-0ddcb219de0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-b558-7309-a44f-2f687b4eaa9a.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two stainless steel grills and palm trees.",
        "public_id": "01a0109e-b558-7309-a44f-2f687b4eaa9a",
        "storage_key": "property/6767906449166451/01a0109e-b558-7309-a44f-2f687b4eaa9a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and entertaining at our community grilling station, complete with modern grills and a scenic backdrop.",
      "link": "",
      "alt_text": "Outdoor grilling station with two stainless steel grills and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_589387d1-1835-4d95-a6dd-73c4cd70c777",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-aa34-75e3-982e-f065318ea017.webp",
      "image_media": {
        "alt_text": "Outdoor fireplace and seating area at apartment complex",
        "public_id": "01a0109e-aa34-75e3-982e-f065318ea017",
        "storage_key": "property/6767906449166451/01a0109e-aa34-75e3-982e-f065318ea017.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors with this stylish fireplace and comfortable seating area, perfect for relaxing evenings. Located at the apartment complex.",
      "link": "",
      "alt_text": "Outdoor fireplace and seating area at apartment complex",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8b11b668-c918-41ba-9429-d159e4cb56db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-f299-7487-a1e5-8000bc110667.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures at Serafina in Goodyear, AZ.",
        "public_id": "01a0109e-f299-7487-a1e5-8000bc110667",
        "storage_key": "property/6767906449166451/01a0109e-f299-7487-a1e5-8000bc110667.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring slides and climbing structures perfect for children.",
      "link": "",
      "alt_text": "Playground with slides and climbing structures at Serafina in Goodyear, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7a88d20a-0fc0-40c7-886b-a399abe713a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-36bf-754c-a985-401291965992.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white countertops.",
        "public_id": "01a0109e-36bf-754c-a985-401291965992",
        "storage_key": "property/6767906449166451/01a0109e-36bf-754c-a985-401291965992.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, sleek stainless steel appliances, and elegant white countertops. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3de2ac5e-6627-4d06-9b32-ec4995ffa65d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-4de7-7688-a546-573af079b21a.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with granite countertops, dark cabinets, and leather chairs.",
        "public_id": "01a0109e-4de7-7688-a546-573af079b21a",
        "storage_key": "property/6767906449166451/01a0109e-4de7-7688-a546-573af079b21a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience modern living with a stylish kitchen and dining area, featuring sleek dark cabinetry, granite countertops, and comfortable seating.",
      "link": "",
      "alt_text": "Modern kitchen and dining area with granite countertops, dark cabinets, and leather chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a62329c9-7907-40ae-bdb4-e1c822c0677b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-3484-73fb-9ede-a7f447aafb99.webp",
      "image_media": {
        "alt_text": "Living room with a gray couch, leather armchair, blue rug, and sliding glass door leading to a patio at Serafina in Goodyear, AZ.",
        "public_id": "01a0109e-3484-73fb-9ede-a7f447aafb99",
        "storage_key": "property/6767906449166451/01a0109e-3484-73fb-9ede-a7f447aafb99.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable gray sofa, accent armchair, and a geometric blue rug. Sliding glass doors open to a private patio area, perfect for relaxation.",
      "link": "",
      "alt_text": "Living room with a gray couch, leather armchair, blue rug, and sliding glass door leading to a patio at Serafina in Goodyear, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dfbceb79-ac10-4209-8f0d-36e63263a707",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-b801-7510-9c4d-3c95d27fb5d8.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, TV, and sliding glass doors leading to a patio at Serafina in Goodyear, AZ.",
        "public_id": "01a0109e-b801-7510-9c4d-3c95d27fb5d8",
        "storage_key": "property/6767906449166451/01a0109e-b801-7510-9c4d-3c95d27fb5d8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, modern coffee table, entertainment center with a mounted TV, and direct access to an outdoor patio.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, TV, and sliding glass doors leading to a patio at Serafina in Goodyear, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_da876369-1c8b-4a0f-a359-a4157f231584",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-18b2-77bc-90f2-348ea35aedb8.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, nightstands, and a large window at Serafina in Goodyear, AZ.",
        "public_id": "01a0109e-18b2-77bc-90f2-348ea35aedb8",
        "storage_key": "property/6767906449166451/01a0109e-18b2-77bc-90f2-348ea35aedb8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-sized bed with crisp white linens, stylish nightstands with lamps, and a large window overlooking the property's grounds.",
      "link": "",
      "alt_text": "Bedroom with a queen-sized bed, nightstands, and a large window at Serafina in Goodyear, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a4c43276-9324-41a1-96aa-dedcc4f66649",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-8000-74f3-a531-f094fa2b7b2d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a soaking tub, toilet, and vanity with a large mirror and walk-in closet at Serafina in Goodyear, AZ.",
        "public_id": "01a0109e-8000-74f3-a531-f094fa2b7b2d",
        "storage_key": "property/6767906449166451/01a0109e-8000-74f3-a531-f094fa2b7b2d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into luxury with this modern bathroom featuring a deep soaking tub, elegant vanity, and a spacious walk-in closet, perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with a soaking tub, toilet, and vanity with a large mirror and walk-in closet at Serafina in Goodyear, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b7ee8384-a795-4255-b571-3b0656c34b8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/01a0109e-6419-7253-8064-9442429a999b.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, ceiling fan, and window view at Serafina in Goodyear, AZ.",
        "public_id": "01a0109e-6419-7253-8064-9442429a999b",
        "storage_key": "property/6767906449166451/01a0109e-6419-7253-8064-9442429a999b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and well-appointed bedroom featuring a comfortable queen-size bed, modern ceiling fan, and a large window offering a view of the community's greenery.",
      "link": "",
      "alt_text": "Bedroom with a large bed, ceiling fan, and window view at Serafina in Goodyear, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aef4ddf7-eba4-48cc-9ff9-fc7fbfd302ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019f66a8-c213-73ce-9dc4-6b6b3ef81ec0.webp",
      "image_media": {
        "alt_text": "Balcony view of apartment buildings and landscaping at Serafina in Goodyear, AZ.",
        "public_id": "019f66a8-c213-73ce-9dc4-6b6b3ef81ec0",
        "storage_key": "property/6767906449166451/019f66a8-c213-73ce-9dc4-6b6b3ef81ec0.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on this private balcony, offering serene views of the community's lush landscaping and buildings.",
      "link": "",
      "alt_text": "Balcony view of apartment buildings and landscaping at Serafina in Goodyear, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/88fcd3f0/dms3rep/multi/5742705921490944/6767906449166451/bec5906129b35ead5dc535b27bf4fa97.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a9a52f97-492e-4ed3-8f10-2ab6438b7e6d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Estrella Mountain Community College",
      "poi_type": "Education",
      "poi_address": "3000 N Dysart Rd, Avondale, AZ 85392, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-b866-722f-b840-eb5b20fe872c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-b866-722f-b840-eb5b20fe872c",
        "storage_key": "property/6767906449166451/019d02cc-b866-722f-b840-eb5b20fe872c.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.estrellamountain.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4665022389538055813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "estrella-mountain-community-college",
      "poi_latitude": "33.4804594",
      "poi_longitude": "-112.3434634",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 623-935-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-eaca-7030-bc31-ed5b661542c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-eaca-7030-bc31-ed5b661542c5",
        "storage_key": "property/6767906449166451/019d02cc-eaca-7030-bc31-ed5b661542c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiwz_o1dHK4cRheaonSV9vUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a88452f9-cd93-44f9-a835-dba6ec3eca5c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Georgia T. Lord Library",
      "poi_type": "Education",
      "poi_address": "1900 N Civic Sq, Goodyear, AZ 85395, USA",
      "poi_short_description": "Kid-friendly library featuring a soft-toy area, a computer center and a game-rental service.",
      "poi_long_description": "People say this public library offers study rooms, a kids area with books, DVDs and computers, and an outdoor area to read and relax. They also highlight the helpful staff, free game rentals, and the ever-changing art exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-b91a-770a-8cbf-4fa49ce02db2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-b91a-770a-8cbf-4fa49ce02db2",
        "storage_key": "property/6767906449166451/019d02cc-b91a-770a-8cbf-4fa49ce02db2.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://mcldaz.org/locations/goodyear/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9380305639711408854&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "georgia-t-lord-library",
      "poi_latitude": "33.4679234",
      "poi_longitude": "-112.3855114",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 602-652-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-eaca-7030-bc31-ed5b661542c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-eaca-7030-bc31-ed5b661542c5",
        "storage_key": "property/6767906449166451/019d02cc-eaca-7030-bc31-ed5b661542c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnTv_evI4K4cR1oKXw0eKLYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_0a5bf2dd-0a60-4f5d-89a8-13d92593472f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "15305 W McDowell Rd, Goodyear, AZ 85395, USA",
      "poi_short_description": "Huge indoor amusement center, featuring trampolines, a ropes course, arcade games and a cafe.",
      "poi_long_description": "People say this amusement park offers a variety of attractions, including trampolines, a zipline, and a ropes course, and is a fun place for kids to burn off energy. They also highlight the friendly and helpful staff, and the easy birthday party experience.\n\nOther reviews mention the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-bcd8-7479-bc7b-9ccf3610e250.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-bcd8-7479-bc7b-9ccf3610e250",
        "storage_key": "property/6767906449166451/019d02cc-bcd8-7479-bc7b-9ccf3610e250.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/arizona-goodyear/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=4454067814043586297&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "33.4627384",
      "poi_longitude": "-112.3890052",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 623-209-8840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9",
        "storage_key": "property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa4y3mXs4K4cR-Y6RBRQH0D0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_060c1e81-fb7f-49f7-9c11-0ed93963f080",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "15305 W McDowell Rd, Goodyear, AZ 85395, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-c265-7594-9319-bc3f8292a539.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-c265-7594-9319-bc3f8292a539",
        "storage_key": "property/6767906449166451/019d02cc-c265-7594-9319-bc3f8292a539.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/az-goodyear",
      "poi_directions_map_url": "https://maps.google.com/?cid=1607731950139889773&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "33.4625912",
      "poi_longitude": "-112.3886482",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 623-343-3835",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9",
        "storage_key": "property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdVXxwK45K4cRbVgixrDPTxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_27592669-cd9b-42bb-98c7-7016545fdbd6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "15277 W McDowell Rd, Goodyear, AZ 85395, USA",
      "poi_short_description": "Down-to-earth gym featuring standard equipment and group classes, plus a kids' club and sauna.",
      "poi_long_description": "People say this gym offers a wide variety of workout equipment, including cardio machines, weightlifting equipment, and a sauna. They also highlight the friendly and helpful staff, and the clean and well-maintained facilities.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-c280-773e-9317-23960b0b5350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-c280-773e-9317-23960b0b5350",
        "storage_key": "property/6767906449166451/019d02cc-c280-773e-9317-23960b0b5350.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/goodyear-n-pebble-creek-pkwy-i-10/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14603638828047898452&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.4625049",
      "poi_longitude": "-112.3875162",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-542-2747",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9",
        "storage_key": "property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9VxulrA5K4cRVJflBSSMqso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4152dc35-f22e-4845-94d0-3fa4db8cb8f4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "14540 W McDowell Rd, Goodyear, AZ 85395, USA",
      "poi_short_description": "Spacious gym featuring group classes and cardio machines as well as an indoor pool and an outdoor pool.",
      "poi_long_description": "Visitors say this gym has a great selection of equipment, a spacious layout, and a convenient on-site cafeteria with healthy food options. They also highlight the family-friendly atmosphere with amenities like pools and a kids' area, as well as the well-maintained locker rooms and spa facilities.\n\nSome reviews mention the membership fees can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-c433-756f-9ff4-8de2d2b188af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-c433-756f-9ff4-8de2d2b188af",
        "storage_key": "property/6767906449166451/019d02cc-c433-756f-9ff4-8de2d2b188af.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/az/palm-valley.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=7875332328598297832&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "33.4658771",
      "poi_longitude": "-112.3715062",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 623-536-9595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9",
        "storage_key": "property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp6ue5IQ4K4cR6FxADgfNSm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e86a85ba-c9dc-431f-a3dc-3e2e599a1480",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1382 S Cotton Ln, Goodyear, AZ 85338, USA",
      "poi_short_description": "Family-friendly health club chain featuring a gym with clean equipment, classes and an indoor pool.",
      "poi_long_description": "People say this gym offers a wide variety of machines and equipment, and has a pool and daycare. They also highlight the clean facilities, welcoming atmosphere, and friendly, helpful staff.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-c963-7159-bb86-29c678ef15d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-c963-7159-bb86-29c678ef15d7",
        "storage_key": "property/6767906449166451/019d02cc-c963-7159-bb86-29c678ef15d7.webp",
        "width": 1280,
        "height": 686
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=531&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7992039061644918177&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.4340695",
      "poi_longitude": "-112.4296121",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-422-6088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9",
        "storage_key": "property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVW_KGSE4K4cRoT1k1C5t6W4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8b2b083a-89dd-462b-80fe-f7cbb542ef3b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "BluePearl Pet Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "13034 W Rancho Santa Fe Blvd Ste. 101, Avondale, AZ 85392, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-cadb-717b-9006-489f8af65e43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-cadb-717b-9006-489f8af65e43",
        "storage_key": "property/6767906449166451/019d02cc-cadb-717b-9006-489f8af65e43.webp",
        "width": 1024,
        "height": 587
      },
      "poi_business_url": "https://bluepearlvet.com/hospital/avondale-az/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7929150564691392023&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluepearl-pet-hospital",
      "poi_latitude": "33.4617039",
      "poi_longitude": "-112.3363964",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 623-385-4555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9",
        "storage_key": "property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGV5JArU4K4cRF7YEm20ACm4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_061c18c4-5d90-4d2e-b83d-a56a2cb27871",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "515 S Cotton Ln, Goodyear, AZ 85338, USA",
      "poi_short_description": "Chain fitness center offering a variety of equipment, tanning, and massages, plus a restroom.",
      "poi_long_description": "People say this gym offers a variety of equipment. They also highlight the affordable prices, friendly staff, and clean facilities.\n\nOther reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-c5ad-723c-92e8-fe8841e15680.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-c5ad-723c-92e8-fe8841e15680",
        "storage_key": "property/6767906449166451/019d02cc-c5ad-723c-92e8-fe8841e15680.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/goodyear-az?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=8356517283917529796&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.4419775",
      "poi_longitude": "-112.4231215",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 623-900-2005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9",
        "storage_key": "property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ44syMCA4K4cRxAJR6zFQ-HM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fb84200a-ba60-4d29-9d17-501172485dfd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Southwest Valley Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2919 N Litchfield Rd, Goodyear, AZ 85395, USA",
      "poi_short_description": "Non-profit gym featuring pools, a basketball court, and group classes, plus childcare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-cb6e-70c2-aaf6-5557227e18bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-cb6e-70c2-aaf6-5557227e18bf",
        "storage_key": "property/6767906449166451/019d02cc-cb6e-70c2-aaf6-5557227e18bf.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://valleyymca.org/southwest-valley/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15238733355172004664&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southwest-valley-family-ymca",
      "poi_latitude": "33.4790287",
      "poi_longitude": "-112.3585689",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 623-935-5193",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9",
        "storage_key": "property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5UEvkmBHK4cROIPsjT_betM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d54bb6a1-fa21-443c-b8bf-1077a5926734",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Abrazo West Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "13677 W McDowell Rd, Goodyear, AZ 85395, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-cdc4-703a-abda-fffc4f285eb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-cdc4-703a-abda-fffc4f285eb7",
        "storage_key": "property/6767906449166451/019d02cc-cdc4-703a-abda-fffc4f285eb7.webp",
        "width": 1280,
        "height": 643
      },
      "poi_business_url": "https://www.abrazohealth.com/locations/detail/abrazo-west-campus/?utm_campaign=gmb_listings_mgmt&utm_source=gmb-abrazo-west-campus&utm_medium=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1072554981668413270&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "abrazo-west-campus",
      "poi_latitude": "33.4616973",
      "poi_longitude": "-112.3534925",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 623-882-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-f07e-758b-9c3b-588a01cf4c57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-f07e-758b-9c3b-588a01cf4c57",
        "storage_key": "property/6767906449166451/019d02cc-f07e-758b-9c3b-588a01cf4c57.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_3qLcbw4K4cRVt9rvBJ74g4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a2aef8bb-90b4-4083-8b94-a0fd5b6d9346",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Friendship Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12325 W McDowell Rd, Avondale, AZ 85323, USA",
      "poi_short_description": "Playgrounded park with baseball and soccer fields, plus a splash pad and tennis courts.",
      "poi_long_description": "People say this park offers a variety of activities, including playgrounds, sports fields, a walking trail, a dog park, picnic areas, and a fishing pond with ducks and geese. They highlight the clean and well-maintained facilities, and the family-friendly vibe. They also like the friendly staff and the ample parking. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-cfe7-754c-bf21-9da4da4767f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-cfe7-754c-bf21-9da4da4767f1",
        "storage_key": "property/6767906449166451/019d02cc-cfe7-754c-bf21-9da4da4767f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.avondaleaz.gov/government/departments/parks-recreation/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=17309830429229523955&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "friendship-park",
      "poi_latitude": "33.4604627",
      "poi_longitude": "-112.3226161",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 623-333-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-f57f-7718-ac80-45c5cddf1809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-f57f-7718-ac80-45c5cddf1809",
        "storage_key": "property/6767906449166451/019d02cc-f57f-7718-ac80-45c5cddf1809.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt_rvMEg_K4cR8yN5YBDfOPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fc6d075c-f1a6-48c4-92c5-28a46146cd2f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Wigwam Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "451 N Old Litchfield Rd, Litchfield Park, AZ 85340, USA",
      "poi_short_description": "Set amid mountains and trees, this resort offers 3 championship golf courses with a practice range.",
      "poi_long_description": "People say this golf course offers three courses in great condition, with fair, wide fairways and resort-style golf. They also highlight the beautiful grounds, delicious food, and friendly, helpful staff.\n\nOther reviews mention the pace of play can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-d255-710a-8b86-516abce2ebb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-d255-710a-8b86-516abce2ebb2",
        "storage_key": "property/6767906449166451/019d02cc-d255-710a-8b86-516abce2ebb2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wigwamgolf.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=11226189925095227131&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wigwam-golf-club",
      "poi_latitude": "33.4982505",
      "poi_longitude": "-112.3573454",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 623-935-9414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-f60f-776d-85f2-9449aed5a03e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-f60f-776d-85f2-9449aed5a03e",
        "storage_key": "property/6767906449166451/019d02cc-f60f-776d-85f2-9449aed5a03e.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJGflYeRVHK4cR-75eCkJwy5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_89229a40-a50a-47eb-8201-723bc582883e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Festival Fields Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "101 E Lower Buckeye Rd, Avondale, AZ 85323, USA",
      "poi_short_description": "Grass-free, kid-friendly park (also for adults) with a skateboard area as well as a splash pad, a lake, and ball fields.",
      "poi_long_description": "People say this park offers a splash pad, playground, fishing pond, pickleball courts, and picnic areas. They highlight the clean facilities, spacious layout, and fun amenities for families. They also like the well-maintained courts and the relaxing atmosphere for fishing and picnics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-d32d-7125-a4be-af80dd338f86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-d32d-7125-a4be-af80dd338f86",
        "storage_key": "property/6767906449166451/019d02cc-d32d-7125-a4be-af80dd338f86.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11965206082426049739&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "festival-fields-park",
      "poi_latitude": "33.4189918",
      "poi_longitude": "-112.349516",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 623-333-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-f57f-7718-ac80-45c5cddf1809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-f57f-7718-ac80-45c5cddf1809",
        "storage_key": "property/6767906449166451/019d02cc-f57f-7718-ac80-45c5cddf1809.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWcA2js5K4cRyxRZn4nzDKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7b33d3b3-fdf9-4af3-bfea-6714b57122be",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Palm Valley Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2211 N Litchfield Rd, Goodyear, AZ 85395, USA",
      "poi_short_description": "Designed by Arthur Hills, this 27-hole golf course has a driving range and other practice facilities.",
      "poi_long_description": "People say this golf course offers a fun layout and fast, true greens. They also highlight the nice patio for drinks after the round and the professional staff.\n\nOther reviews mention the course condition can be poor.",
      "poi_featured_image": "https://storage.googleapis.com/neighborhood-poi-images/5742705921490944%2F6767906449166451%2Fc4dea99eaf5abbdb920831c1df8eaf6c.jpg",
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.palmvalleygolf.com/?utm_source=google&utm_medium=organic&utm_campaign=google_business_profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=10450760988907081185&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "palm-valley-golf-club",
      "poi_latitude": "33.4708018",
      "poi_longitude": "-112.3569774",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 623-935-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-f60f-776d-85f2-9449aed5a03e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-f60f-776d-85f2-9449aed5a03e",
        "storage_key": "property/6767906449166451/019d02cc-f60f-776d-85f2-9449aed5a03e.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJW37ddKE4K4cR4Q1RuL-PCJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_50919ff6-1235-4d5b-9601-9a0528b909f2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Alamar Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4155 S El Mirage Rd, Avondale, AZ 85323, USA",
      "poi_short_description": "Family-friendly park featuring baseball and soccer fields, basketball and tennis courts, a dog park, and playgrounds plus a fishing lake.",
      "poi_long_description": "Visitors say this park is clean and well-maintained, with plenty of walking paths, playgrounds, and sports facilities, including baseball fields, basketball courts, and tennis courts. They also highlight the park's safety, thanks to its good lighting, and its family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-d4f2-754e-a581-f43a016cbf35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-d4f2-754e-a581-f43a016cbf35",
        "storage_key": "property/6767906449166451/019d02cc-d4f2-754e-a581-f43a016cbf35.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.avondaleaz.gov/government/departments/parks-recreation/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=12902282512567115620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alamar-park",
      "poi_latitude": "33.4081873",
      "poi_longitude": "-112.3210753",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 623-333-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-f57f-7718-ac80-45c5cddf1809.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-f57f-7718-ac80-45c5cddf1809",
        "storage_key": "property/6767906449166451/019d02cc-f57f-7718-ac80-45c5cddf1809.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJubpwhOM_K4cRZB9MAZYdDrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f5754c76-5e15-4b71-aa7b-83d86a6062a0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Phoenix Goodyear Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1658 S Litchfield Rd, Goodyear, AZ 85338, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-d635-7134-8431-d9b4d96671be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-d635-7134-8431-d9b4d96671be",
        "storage_key": "property/6767906449166451/019d02cc-d635-7134-8431-d9b4d96671be.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://goodyearairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=345887828880432200&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phoenix-goodyear-airport",
      "poi_latitude": "33.4245691",
      "poi_longitude": "-112.3729813",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 623-932-4550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-f6d4-76cc-99f2-6c2a44fa11ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-f6d4-76cc-99f2-6c2a44fa11ff",
        "storage_key": "property/6767906449166451/019d02cc-f6d4-76cc-99f2-6c2a44fa11ff.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpWu7mQY5K4cRSJyM1CXXzAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_5ee96527-b752-43be-9b10-b4a10a9afd82",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Goodyear City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1900 N Civic Sq, Goodyear, AZ 85395, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-da64-7559-8ef9-e32feabec63c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-da64-7559-8ef9-e32feabec63c",
        "storage_key": "property/6767906449166451/019d02cc-da64-7559-8ef9-e32feabec63c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.goodyearaz.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7423328594901440787&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "goodyear-city-hall",
      "poi_latitude": "33.4679677",
      "poi_longitude": "-112.3854581",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 623-932-3910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-f75b-7734-a0b7-3d1d4eeca3e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-f75b-7734-a0b7-3d1d4eeca3e6",
        "storage_key": "property/6767906449166451/019d02cc-f75b-7734-a0b7-3d1d4eeca3e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp0kag-A4K4cRE5kZzgb2BGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_ed667952-d8c7-4365-a704-5cbb2a965667",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "City of Avondale",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11465 West, 11465 W Civic Ctr Dr, Avondale, AZ 85323, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-dad7-74b2-ad48-fb9567d58397.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-dad7-74b2-ad48-fb9567d58397",
        "storage_key": "property/6767906449166451/019d02cc-dad7-74b2-ad48-fb9567d58397.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.avondaleaz.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13622991710836474318&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-avondale",
      "poi_latitude": "33.4444488",
      "poi_longitude": "-112.3044385",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 623-333-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-f75b-7734-a0b7-3d1d4eeca3e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-f75b-7734-a0b7-3d1d4eeca3e6",
        "storage_key": "property/6767906449166451/019d02cc-f75b-7734-a0b7-3d1d4eeca3e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6rqDB4_K4cRzsF_hsiWDr0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_47bb536f-1e17-4bfb-b2e8-8c09ccd738f4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Compass Datacenter",
      "poi_type": "Major Employers & Offices",
      "poi_address": "850 S Bullard Ave, Goodyear, AZ 85338, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-dce6-7072-b8bf-5b498056a450.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-dce6-7072-b8bf-5b498056a450",
        "storage_key": "property/6767906449166451/019d02cc-dce6-7072-b8bf-5b498056a450.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12882050967908146577&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "compass-datacenter",
      "poi_latitude": "33.4412199",
      "poi_longitude": "-112.3770066",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9",
        "storage_key": "property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVyoU5E5K4cRkV2kcBo9xrI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_17bb4936-fe38-4e3c-8a04-64b987139b58",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Unical Aviation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15132 W Camelback Rd, Litchfield Park, AZ 85340, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-dfb5-7234-b3b3-8556716d3b4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-dfb5-7234-b3b3-8556716d3b4b",
        "storage_key": "property/6767906449166451/019d02cc-dfb5-7234-b3b3-8556716d3b4b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.unical.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4494611297967600899&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "unical-aviation",
      "poi_latitude": "33.511757",
      "poi_longitude": "-112.3868118",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 909-348-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9",
        "storage_key": "property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqblZr-xHK4cRA_XQeikRYD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3077d850-7a9d-4755-a84a-5d09a604988f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Global Security Operations Center - Amazon",
      "poi_type": "Major Employers & Offices",
      "poi_address": "50003354, 555 N Litchfield Rd work, Goodyear, AZ 85338, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-e21e-7006-b44b-ccce70b7f763.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-e21e-7006-b44b-ccce70b7f763",
        "storage_key": "property/6767906449166451/019d02cc-e21e-7006-b44b-ccce70b7f763.webp",
        "width": 1280,
        "height": 802
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14996783210027426594&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "global-security-operations-center---amazon",
      "poi_latitude": "33.4532985",
      "poi_longitude": "-112.3576078",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9",
        "storage_key": "property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-7gu5VI5K4cRIiM6h99GH9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8dffb6b4-98b3-4164-95c3-02aca53166af",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Copper & Sage Goodyear",
      "poi_type": "Restaurants",
      "poi_address": "1975 N Globe Dr #103, Goodyear, AZ 85395, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this restaurant serves delicious appetizers, including crab cakes and bacon-wrapped dates, and a variety of entrees, such as fish tacos, crispy chicken sandwiches, and shrimp and grits. They also highlight the friendly and attentive service, and the cozy and modern atmosphere.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb2e0-6ddc-7319-861b-3c157953ea87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2e0-6ddc-7319-861b-3c157953ea87",
        "storage_key": "property/6767906449166451/019eb2e0-6ddc-7319-861b-3c157953ea87.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.copperandsageaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3720305810457848542&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "copper--sage-goodyear",
      "poi_latitude": "33.468238",
      "poi_longitude": "-112.3834282",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-322-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ea6a-775a-a1c3-db89963a50b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ea6a-775a-a1c3-db89963a50b1",
        "storage_key": "property/6767906449166451/019d02cc-ea6a-775a-a1c3-db89963a50b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkW8oJW45K4cR3mopcGwuoTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_cbc98330-1976-4057-ad2e-b68eaaed1721",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Bubba's 33",
      "poi_type": "Restaurants",
      "poi_address": "1460 N Bullard Ave, Goodyear, AZ 85395, USA",
      "poi_short_description": "Burgers, pizza & beer served alongside many large-screen TVs showing sports & music videos.",
      "poi_long_description": "Diners say this American restaurant serves up delicious boneless wings, fish and chips, lasagna, onion rings, and burgers, with a wide selection of beers. They also highlight the friendly and attentive service, lively atmosphere, and reasonable prices.\n\nSome reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb2e0-6add-7129-92ab-16bf1466e7b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2e0-6add-7129-92ab-16bf1466e7b9",
        "storage_key": "property/6767906449166451/019eb2e0-6add-7129-92ab-16bf1466e7b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bubbas33.com/locations/arizona/goodyear",
      "poi_directions_map_url": "https://maps.google.com/?cid=16719766190527159505&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bubbas-33",
      "poi_latitude": "33.462681",
      "poi_longitude": "-112.376233",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-220-1038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ea6a-775a-a1c3-db89963a50b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ea6a-775a-a1c3-db89963a50b1",
        "storage_key": "property/6767906449166451/019d02cc-ea6a-775a-a1c3-db89963a50b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7f_-dgA5K4cR0Rz14cOKCOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_1319d5da-5844-4f82-8c63-d66fd2f8be45",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "15255 W McDowell Rd, Goodyear, AZ 85395, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, burgers, and ribs, and the rolls are a favorite. They also highlight the fun, lively atmosphere, and the friendly, attentive service.\n\nSome reviews mention there can be a long wait time.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb2e0-69f9-70f6-a39f-136e456ff5af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2e0-69f9-70f6-a39f-136e456ff5af",
        "storage_key": "property/6767906449166451/019eb2e0-69f9-70f6-a39f-136e456ff5af.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/arizona/goodyear?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=18140483051251544281&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "33.4640823",
      "poi_longitude": "-112.3871787",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-535-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ea6a-775a-a1c3-db89963a50b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ea6a-775a-a1c3-db89963a50b1",
        "storage_key": "property/6767906449166451/019d02cc-ea6a-775a-a1c3-db89963a50b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAf-aCHw4K4cR2bDXAznxv_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_4558a5e0-d2e9-4e85-98b4-9bf470861e16",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "14950 W McDowell Rd, Goodyear, AZ 85395, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "People say this restaurant serves delicious prime rib, wings, and pizookies. They also highlight the attentive and friendly staff, and the great lunch and pizookie specials.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb2e0-67a7-7043-aa44-c87dd8982ebf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2e0-67a7-7043-aa44-c87dd8982ebf",
        "storage_key": "property/6767906449166451/019eb2e0-67a7-7043-aa44-c87dd8982ebf.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.bjsrestaurants.com/locations/az/goodyear?utm_source=google&utm_medium=organic&utm_campaign=google_my_business",
      "poi_directions_map_url": "https://maps.google.com/?cid=2559035045563438702&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bjs-restaurant--brewhouse",
      "poi_latitude": "33.4648834",
      "poi_longitude": "-112.3806736",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-863-9420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ea6a-775a-a1c3-db89963a50b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ea6a-775a-a1c3-db89963a50b1",
        "storage_key": "property/6767906449166451/019d02cc-ea6a-775a-a1c3-db89963a50b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJaRsE_85K4cRbpaVytCEgyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7118ad0a-6b5a-48e8-8ec2-51de97670314",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Saddle Mountain Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "15651 West Roosevelt St, Goodyear, AZ 85338, USA",
      "poi_short_description": "Brew pub serving craft beer and burgers, plus steaks, wings and fish dishes.",
      "poi_long_description": "Reviewers consistently praise this brewery for its fun and relaxed atmosphere, a great selection of craft beers, and enjoyable outdoor seating and live music. Patrons also praise the good burgers, fish and chips, and jalapeño dip, complemented by the friendly staff.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb2e0-6995-7668-a6b9-5ad8f1e3b548.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2e0-6995-7668-a6b9-5ad8f1e3b548",
        "storage_key": "property/6767906449166451/019eb2e0-6995-7668-a6b9-5ad8f1e3b548.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.saddlemountainbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5174285074340051529&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "saddle-mountain-brewing-company",
      "poi_latitude": "33.45640900000001",
      "poi_longitude": "-112.395652",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-249-5520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ea6a-775a-a1c3-db89963a50b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ea6a-775a-a1c3-db89963a50b1",
        "storage_key": "property/6767906449166451/019d02cc-ea6a-775a-a1c3-db89963a50b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvYSDt284K4cRSfqkTtzAzkc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_baf5ed14-e29b-4f14-9817-a25e6245691f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "The Breakaway Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "633 Estrella Pkwy, Goodyear, AZ 85338, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this restaurant serves delicious burgers, fries, and drinks. They also highlight the friendly and attentive service, and the fun sports bar vibe with a pool table and darts.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb2e0-6df0-706a-bd4b-282a44337c0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2e0-6df0-706a-bd4b-282a44337c0e",
        "storage_key": "property/6767906449166451/019eb2e0-6df0-706a-bd4b-282a44337c0e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thebreakawayaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1189525791281579205&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-breakaway-bar--grill",
      "poi_latitude": "33.4405345",
      "poi_longitude": "-112.3920574",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-248-9086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ea6a-775a-a1c3-db89963a50b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ea6a-775a-a1c3-db89963a50b1",
        "storage_key": "property/6767906449166451/019d02cc-ea6a-775a-a1c3-db89963a50b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfd-YlMM5K4cRxQSBoGcLghA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9760edca-987a-42f6-a251-b41f323c5b02",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "995 S Cotton Ln, Goodyear, AZ 85338, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Visitors consistently praise this store for being clean and well-stocked, offering a large selection of groceries with particularly great deals on markdown meat. The staff are also frequently mentioned for their friendly demeanor.\n\nSome reviews mention the checkout lines can be long and slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb2e0-6637-7398-89f6-77a5721581c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2e0-6637-7398-89f6-77a5721581c0",
        "storage_key": "property/6767906449166451/019eb2e0-6637-7398-89f6-77a5721581c0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/goodyear-west/2400",
      "poi_directions_map_url": "https://maps.google.com/?cid=15992624866358781601&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.4377212",
      "poi_longitude": "-112.4215774",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-627-3275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ea9d-7143-80d8-1aa0ab33cebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ea9d-7143-80d8-1aa0ab33cebe",
        "storage_key": "property/6767906449166451/019d02cc-ea9d-7143-80d8-1aa0ab33cebe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJObDx8iM4K4cRoeZkWZU38d0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_db7bed78-727f-4332-97c7-90fe0a36a635",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "1855 Pebble Creek Pkwy, Goodyear, AZ 85395, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb2e0-6b2b-746f-92b1-4fc7e98f4756.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2e0-6b2b-746f-92b1-4fc7e98f4756",
        "storage_key": "property/6767906449166451/019eb2e0-6b2b-746f-92b1-4fc7e98f4756.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.homegoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12674024443818375042&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "homegoods",
      "poi_latitude": "33.467502",
      "poi_longitude": "-112.389014",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-536-6852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ea9d-7143-80d8-1aa0ab33cebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ea9d-7143-80d8-1aa0ab33cebe",
        "storage_key": "property/6767906449166451/019d02cc-ea9d-7143-80d8-1aa0ab33cebe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdWj6-LQ5K4cRgndp8BQu468",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_b6d04657-1b21-4881-a552-b8e80aef0f8b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Michaels",
      "poi_type": "Shopping & Retail",
      "poi_address": "885 S Cotton Ln Canyon Trails Towne Center, Goodyear, AZ 85338, USA",
      "poi_short_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_long_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb2e0-662e-76be-98fe-3bdf7ee435a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2e0-662e-76be-98fe-3bdf7ee435a3",
        "storage_key": "property/6767906449166451/019eb2e0-662e-76be-98fe-3bdf7ee435a3.webp",
        "width": 1192,
        "height": 791
      },
      "poi_business_url": "https://locations.michaels.com/AZ/Goodyear/5575/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=17393093371964483246&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "michaels",
      "poi_latitude": "33.4385825",
      "poi_longitude": "-112.4216028",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-691-3323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ea9d-7143-80d8-1aa0ab33cebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ea9d-7143-80d8-1aa0ab33cebe",
        "storage_key": "property/6767906449166451/019d02cc-ea9d-7143-80d8-1aa0ab33cebe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-__zCCI5K4cRruYk7USuYPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_c6e86c65-a18c-4b9a-9fe4-4964448c2ddd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Tanger Outlets Phoenix",
      "poi_type": "Shopping & Retail",
      "poi_address": "6800 N 95th Ave, Glendale, AZ 85305, USA",
      "poi_short_description": "Shopping-mall chain featuring a variety of brand-name & designer outlet stores.",
      "poi_long_description": "People say this outlet mall offers a wide selection of brand-name stores with great deals and discounts on quality merchandise. Visitors also highlight the clean, well-maintained outdoor environment with ample shaded seating areas and spotless restrooms. They also like the friendly and helpful staff across various stores.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb2e0-6fdc-73cd-8dd0-4569fcd02278.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2e0-6fdc-73cd-8dd0-4569fcd02278",
        "storage_key": "property/6767906449166451/019eb2e0-6fdc-73cd-8dd0-4569fcd02278.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tangeroutlet.com/glendale",
      "poi_directions_map_url": "https://maps.google.com/?cid=16253464825419077885&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tanger-outlets-phoenix",
      "poi_latitude": "33.5341547",
      "poi_longitude": "-112.2667464",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-877-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ea9d-7143-80d8-1aa0ab33cebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ea9d-7143-80d8-1aa0ab33cebe",
        "storage_key": "property/6767906449166451/019d02cc-ea9d-7143-80d8-1aa0ab33cebe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNyV8OEtAK4cR_Rhp6CToj-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4536f802-c04e-48d0-88d5-e1a27078f874",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Canyon Trails Towne Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "S. Cotton Ln. and, W Yuma Rd, Goodyear, AZ 85338, USA",
      "poi_short_description": "Laid-back shopping center featuring an array of stores and restaurants (including sushi establishments) along with a gym.",
      "poi_long_description": "Visitors say this shopping center offers a wide variety of stores, including popular outlets and craft shops, with quality products. They also highlight the good prices, clean environment, and ample parking.\n\nSome reviews mention the parking can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb2e0-7a97-761f-afeb-059a0f25a810.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2e0-7a97-761f-afeb-059a0f25a810",
        "storage_key": "property/6767906449166451/019eb2e0-7a97-761f-afeb-059a0f25a810.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://shopcanyontrails.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17153077909191619759&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "canyon-trails-towne-center",
      "poi_latitude": "33.437608",
      "poi_longitude": "-112.4235339",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ea9d-7143-80d8-1aa0ab33cebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ea9d-7143-80d8-1aa0ab33cebe",
        "storage_key": "property/6767906449166451/019d02cc-ea9d-7143-80d8-1aa0ab33cebe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2fAOLic4K4cRr3T3PXr5C-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_acd83b9d-7c82-4231-bef4-32e07a0196ee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Westgate Entertainment District",
      "poi_type": "Shopping & Retail",
      "poi_address": "6770 N Sunrise Blvd, Glendale, AZ 85305",
      "poi_short_description": "Sprawling shopping complex with national retailers, restaurants & live music on weekends.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://westgateaz.com/",
      "poi_directions_map_url": "https://www.google.com/maps/place/Westgate+Entertainment+District/data=!4m2!3m1!1s0x0:0xfaa5473d254165b0?sa=X&ved=1t:2428&ictx=111",
      "poi_item_slug": "false",
      "poi_latitude": "33.5338631",
      "poi_longitude": "-112.2606626",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8caa4d8b-3f2d-433a-ae0f-92176643ad8c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Harkins Theatres Estrella Falls",
      "poi_type": "Entertainment",
      "poi_address": "15010 W McDowell Rd, Goodyear, AZ 85395, USA",
      "poi_short_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_long_description": "People say this movie theater offers comfortable, reclining seats and a wide variety of food and drink options, including a full bar. They also highlight the consistently clean facilities, including the restrooms, and the friendly, helpful staff. Visitors appreciate the easy online ticketing and ample parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb2e0-7355-775a-8f09-2b8ec15c57ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2e0-7355-775a-8f09-2b8ec15c57ec",
        "storage_key": "property/6767906449166451/019eb2e0-7355-775a-8f09-2b8ec15c57ec.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://harkins.com/theatres/estrella-falls/?utm_source=google_listing&utm_medium=web&utm_campaign=gmb&utm_id=local_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13226109798179406500&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "harkins-theatres-estrella-falls",
      "poi_latitude": "33.4675232",
      "poi_longitude": "-112.381428",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-223-1105",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb2e0-8027-72a4-86d4-7ea58c042402.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eb2e0-8027-72a4-86d4-7ea58c042402",
        "storage_key": "property/6767906449166451/019eb2e0-8027-72a4-86d4-7ea58c042402.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJn5l5ooA4K4cRpALMWMmUjLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_f9814f73-f506-4178-9fce-c8fed88db2fc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Phoenix Raceway",
      "poi_type": "Entertainment",
      "poi_address": "7602 Jimmie Johnson Dr, Avondale, AZ 85323, USA",
      "poi_short_description": "Stock-car racetrack & event destination with seating capacity for more than 65,000 fans.",
      "poi_long_description": "Visitors say this raceway offers a great race-day experience with plenty of food and drink options, clean restrooms, and a fantastic fan zone with displays and entertainment. They also highlight the well-organized facility, helpful staff, and convenient parking with tram service. Guests mention the overall fun and family-friendly atmosphere, with many activities to enjoy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb2e0-7170-745f-a21b-6a9f20044c6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2e0-7170-745f-a21b-6a9f20044c6d",
        "storage_key": "property/6767906449166451/019eb2e0-7170-745f-a21b-6a9f20044c6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.phoenixraceway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12808267634728492091&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "phoenix-raceway",
      "poi_latitude": "33.3750416",
      "poi_longitude": "-112.3111542",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-463-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9",
        "storage_key": "property/6767906449166451/019d02cc-ef61-70f8-aaa2-a2f3fb1b71a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1ebbRm08K4cRO9wffI0bwLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    },
    {
      "id": "custom_0e61cc35-c99a-4767-8584-ced2d7d03e3c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Buc-ee's",
      "poi_type": "Entertainment",
      "poi_address": "1001 N Bullard Ave, Goodyear, AZ 85338, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb2e0-72c8-76a3-9a80-391a793983f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb2e0-72c8-76a3-9a80-391a793983f7",
        "storage_key": "property/6767906449166451/019eb2e0-72c8-76a3-9a80-391a793983f7.webp",
        "width": 1135,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3920484305960738131&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "buc-ees-opening-june-22nd-2026--6am",
      "poi_latitude": "33.4572643",
      "poi_longitude": "-112.3738674",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb2e0-8028-73d9-8852-8baf1a043382.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eb2e0-8028-73d9-8852-8baf1a043382",
        "storage_key": "property/6767906449166451/019eb2e0-8028-73d9-8852-8baf1a043382.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzPLWQA5K4cRU51IZLRbaDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_5408ef2f-551d-4ff2-8793-5c4bcb67b5a3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Shopping & Retail",
      "poi_address": "1450 N Litchfield Rd, Goodyear, AZ 85395, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Visitors say this beauty store offers a wide variety of makeup, fragrances, and beauty products, with many highlighting the helpful staff who provide excellent guidance. They also appreciate the pleasant atmosphere, easy parking, and availability of handicapped spaces.\n\nSome reviews mention that items can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019eb410-0cec-719a-8e34-34f0db7f79da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb410-0cec-719a-8e34-34f0db7f79da",
        "storage_key": "property/6767906449166451/019eb410-0cec-719a-8e34-34f0db7f79da.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/goodyear-az-157",
      "poi_directions_map_url": "https://maps.google.com/?cid=15691767144127626803&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "33.4637869",
      "poi_longitude": "-112.361028",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-935-4186",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-ea9d-7143-80d8-1aa0ab33cebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ea9d-7143-80d8-1aa0ab33cebe",
        "storage_key": "property/6767906449166451/019d02cc-ea9d-7143-80d8-1aa0ab33cebe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4Rmj0Zc4K4cRM37fOxRbxNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cosmetics_store"
    },
    {
      "id": "custom_5babd08f-19f2-40c4-96d3-06249cc2be9f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Copper Trails School (PK-8)",
      "poi_type": "Education",
      "poi_address": "16875 W Canyon Trails Blvd, Goodyear, AZ 85338",
      "poi_short_description": "Zoned PK-8 (elementary and middle) for Canyon Trails (Avondale ESD).",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "20",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_36d6e27b-210a-46f1-af73-632053ba73f8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Desert Edge High School",
      "poi_type": "Education",
      "poi_address": "15778 W Yuma Rd, Goodyear, AZ 85338",
      "poi_short_description": "Zoned Agua Fria UHSD high school for Canyon Trails.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "50",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d2eccf1d-7631-46a2-aeae-73fc60193b3f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Estrella Mountain Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14805 W Vineyard Ave, Goodyear, AZ 85338",
      "poi_short_description": "About 20,000-acre county park with 30+ miles of trails (famous regional park).",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "100",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_87b9f6e9-93ad-4821-8741-aef4b22abc31",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Goodyear Park-and-Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "13183 W Cornerstone Blvd, Goodyear, AZ 85395",
      "poi_short_description": "400+ stall transit hub; departure point for the Route 562 express.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "80",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f8f2517d-c315-4463-86b7-ee89ccecc348",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Valley Metro Route 562 (Goodyear Express)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Goodyear Park-and-Ride, Goodyear, AZ 85395",
      "poi_short_description": "Weekday express bus to downtown Phoenix.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "80",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c4d8cc5c-b997-4199-8dce-ad5097d5a4cf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Valley Metro Route 563 (Avondale/Buckeye Express)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Avondale / Goodyear, AZ",
      "poi_short_description": "Weekday express bus to downtown Phoenix.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "90",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_49ddc014-02df-4e32-8cdc-55a9224524c0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Avondale Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "I-10 & Avondale Blvd, Avondale, AZ 85323",
      "poi_short_description": "Regional west-valley transit hub in the BLVD district.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "120",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ad84e4ce-a9af-4818-bd9a-89b2a67b0a25",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Valley Metro Route 17 - McDowell Rd",
      "poi_type": "Transportation & Transit",
      "poi_address": "McDowell Rd, Avondale, AZ 85323",
      "poi_short_description": "Local east-west bus along McDowell Rd toward central Phoenix.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "110",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_22bc318c-3aa1-4b70-92aa-dce2cd5758c4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Sub-Zero Group, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17215 W Camelback Rd, Goodyear, AZ 85395",
      "poi_short_description": "Luxury appliance manufacturer; major Goodyear employer.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "100",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8579be4b-3b88-4fef-9422-b1adff15e26a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "Andersen Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "W Van Buren St & Bullard Ave, Goodyear, AZ 85338",
      "poi_short_description": "Window and door manufacturer; large Goodyear-area workforce.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "110",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ef5f4244-8a17-4add-bb0e-bce17230b1c8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "The Learning Experience - Goodyear",
      "poi_type": "Education",
      "poi_address": "16450 W Yuma Rd, Goodyear, AZ 85338, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019f05e2-5810-7393-a889-4886100c538b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f05e2-5810-7393-a889-4886100c538b",
        "storage_key": "property/6767906449166451/019f05e2-5810-7393-a889-4886100c538b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thelearningexperience.com/centers/goodyear/?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=15434528140761775385&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-learning-experience---goodyear",
      "poi_latitude": "33.4361039",
      "poi_longitude": "-112.4125057",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 623-248-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-eaca-7030-bc31-ed5b661542c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-eaca-7030-bc31-ed5b661542c5",
        "storage_key": "property/6767906449166451/019d02cc-eaca-7030-bc31-ed5b661542c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6-OJvEY5K4cRGT3ggZF1MtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_cdbdd2ac-f9a8-4aa9-ad37-ab36e07c450f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "poi_name": "The Crème School of Goodyear, AZ",
      "poi_type": "Education",
      "poi_address": "15370 W Van Buren St, Goodyear, AZ 85338, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019f05e2-55c8-75d9-93fe-b69f1617c0b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f05e2-55c8-75d9-93fe-b69f1617c0b0",
        "storage_key": "property/6767906449166451/019f05e2-55c8-75d9-93fe-b69f1617c0b0.webp",
        "width": 1079,
        "height": 607
      },
      "poi_business_url": "https://cremedelacreme.com/locations/Goodyear-AZ/?utm_campaign=cdlc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_MTAwMzQ5MDc3MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1717556726634386076&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-crme-school-of-goodyear-az",
      "poi_latitude": "33.4506647",
      "poi_longitude": "-112.3898363",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 623-299-9574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-eaca-7030-bc31-ed5b661542c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-eaca-7030-bc31-ed5b661542c5",
        "storage_key": "property/6767906449166451/019d02cc-eaca-7030-bc31-ed5b661542c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZctiBWc4K4cRnBKgLL781Rc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    }
  ],
  "office_hours": [
    {
      "id": "ec_fd0f56fb349b60c947b94795",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b830cc4a8f67469bbe9296d0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b08862e94a81b4391e8326a9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_22c033edbc476adb2a8a63ed",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_666e645feb8def1b4aaff5f1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_960fd590bddb153097cc3a73",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_7cc33d9e-2169-499d-9d08-6ccfe796289a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "rating": "5.0",
      "name": "Lynn Cooper",
      "text": "I cannot say enough wonderful things about Valerie, one of the on-site property managers at Serafina Apartments!\n\nFrom the very beginning, Val has gone above and beyond to make our experience here an exceptional one. She is not only highly professional and knowledgeable, but also incredibly kind, approachable, and genuine.\n\nShe carries herself with grace and respect, and it’s clear she takes great pride in her work and in caring for the residents.\n\nVal always takes the time to listen, answers every question with patience, and ensures nothing ever slips through the cracks. What has meant the most to me is the love, care, and compassion she has consistently shown my mother. She has gone out of her way to assist her, whether with paperwork, maintenance needs, or simply offering guidance.\n\nEach time, Val responded promptly, followed through completely, and did it all with a warm smile. That level of dedication and consistency is rare and speaks volumes about her character.\n\nIt’s clear that Val doesn’t see this as just a job she truly cares about the people she serves.\n\nShe makes residents feel valued, welcomed, and right at home. Thanks to her attentiveness and support, my mom’s time at Serafina has been smooth, comfortable, and stress-free.\n\nLeasing agents and property managers like Val are truly one of a kind, and I feel extremely fortunate to have had her guidance and support throughout my mom’s stay here.\n\nThank you, Val, for your outstanding service and for making Serafina Apartments such a wonderful place to call home!",
      "date": "2025-09-16",
      "title": ""
    },
    {
      "id": "custom_97e30b01-ec40-429c-8823-3a210a3262e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "rating": "5.0",
      "name": "Leticia Osorio",
      "text": "I had an incredible experience at Serafina Luxury Apartments! From start to finish, the team went above and beyond to make the process smooth and stress-free. Elise and Valerie were absolutely amazing—professional, friendly, and always available to answer any questions. The property manager was also incredibly sweet and welcoming, which really made a difference.\n\nThe leasing agent and assistant manager guided me through every step of the application process, making it quick and easy. I was also impressed with the great deals they offered and how spacious and beautiful the apartments are. If you’re looking for luxury, comfort, and an amazing team to support you, I highly recommend Serafina!",
      "date": "2025-08-07",
      "title": ""
    },
    {
      "id": "custom_22705424-df23-43c6-9373-66b103fb6f1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "rating": "5.0",
      "name": "Alberto Martinez",
      "text": "I’ve had an outstanding experience with Kirsten McElhaney as the property manager. From the very beginning, she has been professional, responsive, and incredibly helpful. Whether I had questions about the lease, needed assistance with maintenance, or just general inquiries, Kirsten always handled everything quickly and with a great attitude.\n\nHer communication is excellent, and she consistently goes above and beyond to ensure residents feel supported and heard. It’s clear that she genuinely cares about the community and the people living in it.\n\nThanks to Kirsten, my leasing experience has been smooth, stress-free, and truly enjoyable. I highly recommend her to anyone looking for a well-managed, welcoming place to call home. I will miss this community from tenant 120",
      "date": "2025-07-09",
      "title": ""
    },
    {
      "id": "custom_bd9638ea-368a-4fcb-88e5-a5415c1c90de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "rating": "5.0",
      "name": "Maeve Botham",
      "text": "Valerie was super helpful in answering questions and was very transparent during the application process! I came away after looking at apartments all over very confident and calm with my decision to sign here. I’m so excited to begin living here in my new apartment. :)",
      "date": "2025-07-08",
      "title": ""
    },
    {
      "id": "custom_0923a9ed-971d-47ee-a5b9-98024ce37d71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "rating": "5.0",
      "name": "Jen Brom",
      "text": "Jose H and Jose G were phenomenal! Had a couple small maintenance things pop up right after move in and they went above and beyond! Thanks for making our first days amazing!",
      "date": "2025-08-30",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_4318ec39-bb74-42d7-9932-f4d46fed8548",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019f6c18-cc21-7023-9580-305013a42e17.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-cc21-7023-9580-305013a42e17",
        "storage_key": "property/6767906449166451/019f6c18-cc21-7023-9580-305013a42e17.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Social Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=b96HfTWcQfp"
    },
    {
      "id": "custom_300826ad-9910-4591-ba2e-99ec960ddf00",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019f6c18-cbec-73dd-9f5f-8eaf59e2cbb9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-cbec-73dd-9f5f-8eaf59e2cbb9",
        "storage_key": "property/6767906449166451/019f6c18-cbec-73dd-9f5f-8eaf59e2cbb9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tp8vNFPimJE"
    },
    {
      "id": "custom_e981a5a8-5e14-4c3e-9ab5-3a6e21939592",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019f6c18-cbc2-7103-966c-463586344a45.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-cbc2-7103-966c-463586344a45",
        "storage_key": "property/6767906449166451/019f6c18-cbc2-7103-966c-463586344a45.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 1137 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=S9swvQZNnZf"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199e001-97b7-7732-87da-88fa1dd8dea8",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-serafina-auto",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "generator",
      "page_item_url": "luxury-apartments-in-unit-laundry-goodyear-az-serafina",
      "search_query": "luxury apartments with in-unit laundry Goodyear AZ",
      "category": "Amenity",
      "h1_title": "Luxury Apartments in Goodyear, AZ",
      "h2_subtitle": "Discover luxury living with in-unit laundry at Serafina. Located in Goodyear, our features offer the perfect blend of convenience and style.",
      "page_copy": "Welcome to Serafina, where luxury living thrives in Goodyear, AZ. Each apartment is thoughtfully designed with in-unit laundry, ensuring convenience and comfort right at home. Spanning one to three bedrooms, our spaces boast elegant quartz countertops, making everyday living and entertaining seamless and stylish.\n\nBeyond the doors of your luxurious apartment, Serafina offers an array of amenities designed for relaxation and fitness. Take a dip in our resort-style swimming pool or boost your energy levels in the state-of-the-art fitness center. Perfectly situated in the heart of Canyon Trails, Serafina is where your stylish, convenient, and vibrant lifestyle begins.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with a waterfall feature and lounge area.",
        "public_id": "019d02cc-a14d-709a-9516-6d20e46ef20c",
        "storage_key": "property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments in Goodyear with Amenities",
      "seo_description": "Find luxury apartments in Goodyear, AZ, with in-unit laundry at Serafina. Experience exquisite living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "generator",
      "page_item_url": "apartments-air-conditioning-canyon-trails-goodyear-serafina",
      "search_query": "apartments with air conditioning in Canyon Trails Goodyear",
      "category": "Amenity",
      "h1_title": "Cool Apartments in Canyon Trails",
      "h2_subtitle": "Stay comfortable with air-conditioned apartments at Serafina. Nestled in Goodyear's Canyon Trails, our community offers comfort and style.",
      "page_copy": "Experience the comfort of Serafina, located in Goodyear's vibrant Canyon Trails neighborhood. Our apartments feature essential air conditioning, ensuring a relaxing and cool environment throughout the year. Choose from our selection of one, two, or three-bedroom layouts, each designed to enhance your lifestyle.\n\nBeyond air-conditioned comfort, Serafina offers exceptional community amenities. Refresh at the resort-style pool, maintain an active lifestyle in our modern fitness center, or unwind with a coffee from our inviting café. Embrace the perfect blend of convenience, style, and comfort at Serafina, your serene sanctuary in Canyon Trails.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with a waterfall feature and lounge area.",
        "public_id": "019d02cc-a14d-709a-9516-6d20e46ef20c",
        "storage_key": "property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments in Canyon Trails",
      "seo_description": "Discover air-conditioned apartments in Canyon Trails, Goodyear, AZ. Experience the comfort and style of Serafina's welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "generator",
      "page_item_url": "poolside-apartments-maricopa-county-az-serafina",
      "search_query": "poolside apartments in Maricopa County AZ",
      "category": "Amenity",
      "h1_title": "Poolside Living in Maricopa County",
      "h2_subtitle": "Enjoy the perks of poolside apartments at Serafina, located in Maricopa County, AZ. Dive into our refreshing lifestyle offerings.",
      "page_copy": "Welcome to Serafina, the premier destination for poolside living in Maricopa County, AZ. Our apartments provide a perfect oasis with a stunning resort-style swimming pool at the heart of our community. Step outside your one, two, or three-bedroom home and enjoy the convenience of a refreshing dip anytime you desire.\n\nBeyond the poolside experiences, Serafina offers a wide array of amenities tailored to suit your lifestyle. From our cutting-edge fitness center to the intimate café area, everything you need is right within reach. Located in vibrant Goodyear, Serafina is the perfect place to enjoy luxurious living with a poolside twist.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with a waterfall feature and lounge area.",
        "public_id": "019d02cc-a14d-709a-9516-6d20e46ef20c",
        "storage_key": "property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Poolside Apartments in Maricopa County",
      "seo_description": "Discover poolside apartments in Maricopa County, AZ at Serafina. Enjoy resort-style amenities and luxurious living in Goodyear.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "generator",
      "page_item_url": "modern-apartments-dishwasher-goodyear-85338-serafina",
      "search_query": "modern apartments with dishwasher Goodyear 85338",
      "category": "Amenity",
      "h1_title": "Modern Apartments in Goodyear with Dishwasher",
      "h2_subtitle": "Enjoy modern living in Goodyear's 85338 at Serafina. Our apartments feature high-quality dishwashers for your convenience.",
      "page_copy": "Discover the perfect fusion of style and functionality at Serafina's modern apartments in Goodyear, 85338. Each home is equipped with a dishwasher, ensuring easy cleanup and more time to relax. Choose from our spacious one, two, or three-bedroom layouts, all thoughtfully designed for modern living.\n\nLocated in the heart of Canyon Trails, Serafina offers more than just a great home. Enjoy energizing sessions at our fitness center, or spend leisurely days at our resort-style swimming pool. Coupled with on-site café conveniences, Serafina provides everything you need to live comfortably and stylishly in Goodyear.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with a waterfall feature and lounge area.",
        "public_id": "019d02cc-a14d-709a-9516-6d20e46ef20c",
        "storage_key": "property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Dishwasher in Goodyear",
      "seo_description": "Explore modern living in Goodyear, AZ 85338 with Serafina's apartments. Featuring dishwashers and upscale amenities, redefine your lifestyle today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-west-goodyear-blvd-serafina",
      "search_query": "fitness center apartments near West Goodyear Boulevard",
      "category": "Amenity",
      "h1_title": "Fitness Apartments Near West Goodyear Blvd",
      "h2_subtitle": "Achieve your fitness goals at Serafina, located near West Goodyear Boulevard. Our apartments feature a state-of-the-art fitness center.",
      "page_copy": "Serafina invites you to explore a lifestyle of health and wellness with our apartments near West Goodyear Boulevard. Our community features a cutting-edge fitness center, designed to cater to all your exercise needs. Choose from our one, two, or three-bedroom apartments, each providing comfort and style.\n\nSituated in Goodyear's desirable Canyon Trails area, Serafina offers more than just a place to live. Take advantage of our resort-style swimming pool, on-site café, and modern fitness facilities to enhance your everyday living. Join us and enjoy a vibrant, active lifestyle at Serafina.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with a waterfall feature and lounge area.",
        "public_id": "019d02cc-a14d-709a-9516-6d20e46ef20c",
        "storage_key": "property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Near West Goodyear Blvd",
      "seo_description": "Discover Serafina's apartments near West Goodyear Blvd equipped with a modern fitness center. Live well, stay fit in Goodyear, AZ.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-goodyear-az-serafina",
      "search_query": "1 bedroom apartments in Goodyear AZ",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Goodyear, AZ",
      "h2_subtitle": "Explore our 1 bedroom apartments in Goodyear, AZ. Serafina offers modern living with luxurious amenities.",
      "page_copy": "Looking for the perfect 1 bedroom apartment in Goodyear, AZ? At Serafina, you'll find contemporary living spaces with exquisite quartz countertops and modern appliances. Our one-bedroom apartments are designed with your comfort in mind, providing a spacious layout that complements your lifestyle.\n\nNestled in the vibrant neighborhood of Canyon Trails, Serafina provides an array of amenities including a resort-style swimming pool, a state-of-the-art fitness center, and a cozy café. With such conveniences at your doorstep, our community is ideal for those seeking both tranquility and excitement in Goodyear.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with a waterfall feature and lounge area.",
        "public_id": "019d02cc-a14d-709a-9516-6d20e46ef20c",
        "storage_key": "property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Goodyear, AZ",
      "seo_description": "Find your perfect 1 bedroom apartment at Serafina in Goodyear, AZ. Enjoy modern living and luxe amenities in the Canyon Trails neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-canyon-trails-serafina",
      "search_query": "2 bedroom apartments Canyon Trails",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Canyon Trails",
      "h2_subtitle": "Discover spacious 2 bedroom apartments in Canyon Trails at Serafina. Perfect for families or roommates seeking comfortable living.",
      "page_copy": "Experience the best of Goodyear living with our 2 bedroom apartments in Canyon Trails at Serafina. Each apartment is crafted with meticulous attention to detail, featuring elegant quartz countertops and plenty of room to relax and entertain. Whether you're a family, a couple, or roommates, these layouts offer versatility and style.\n\nBeyond the comforts of home, Serafina provides exceptional community amenities such as a resort-style swimming pool, a fully-equipped fitness center, and a welcoming café. Located in the desirable Canyon Trails neighborhood, you're perfectly positioned to enjoy everything Goodyear has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with a waterfall feature and lounge area.",
        "public_id": "019d02cc-a14d-709a-9516-6d20e46ef20c",
        "storage_key": "property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Canyon Trails",
      "seo_description": "Explore Serafina's spacious 2 bedroom apartments in Canyon Trails, offering modern amenities and luxurious living in Goodyear.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-maricopa-county-serafina",
      "search_query": "3 bedroom apartments Maricopa County",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in Maricopa County",
      "h2_subtitle": "Explore 3 bedroom apartments in Maricopa County at Serafina. Perfect for those desiring more space and luxury in Goodyear.",
      "page_copy": "Discover the expansive 3 bedroom apartments available at Serafina in Maricopa County. Our thoughtfully designed layouts offer an abundance of space, perfect for families or individuals needing more room to breathe. Each apartment includes quality finishes like luxurious quartz countertops and high-end appliances, ensuring a comfortable and elegant living environment.\n\nSituated in the vibrant community of Canyon Trails in Goodyear, Serafina offers a range of upscale amenities to enhance your lifestyle. Make use of our resort-style swimming pool, state-of-the-art fitness center, and a cozy café, all contributing to an enriching community experience. Choose Serafina for a spacious and high-quality home in Maricopa County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with a waterfall feature and lounge area.",
        "public_id": "019d02cc-a14d-709a-9516-6d20e46ef20c",
        "storage_key": "property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in Maricopa County",
      "seo_description": "Find spacious 3 bedroom apartments at Serafina in Maricopa County. Enjoy luxury living with top amenities in Goodyear, AZ.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "generator",
      "page_item_url": "apartments-near-estrella-mountain-college-serafina",
      "search_query": "apartments near estrella mountain community college goodyear az",
      "category": "School",
      "h1_title": "Apartments Near Estrella Mountain College",
      "h2_subtitle": "Find ideal apartments near Estrella Mountain Community College in Goodyear, AZ. Serafina offers convenience and comfort.",
      "page_copy": "If you're searching for apartments near Estrella Mountain Community College in Goodyear, AZ, look no further than Serafina. Located just a short drive away, our community offers the perfect blend of convenience and luxury. Choose from our selection of one, two, or three-bedroom apartments, each featuring sophisticated quartz countertops and modern layouts designed for comfort and style.\n\nApart from proximity to the college, Serafina provides a wealth of amenities, including a resort-style swimming pool and a well-equipped fitness center, allowing you to balance study with relaxation. Nestled in the thriving Canyon Trails neighborhood, our community offers easy access to local dining, shopping, and recreational options, making it a prime choice for students and professionals alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with a waterfall feature and lounge area.",
        "public_id": "019d02cc-a14d-709a-9516-6d20e46ef20c",
        "storage_key": "property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Estrella Mountain College",
      "seo_description": "Discover Serafina's apartments near Estrella Mountain Community College in Goodyear, AZ, featuring modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "generator",
      "page_item_url": "apartments-near-abrazo-west-campus-serafina",
      "search_query": "apartments near abrazo west campus goodyear",
      "category": "Hospital",
      "h1_title": "Apartments Near Abrazo West Campus",
      "h2_subtitle": "Explore apartments near Abrazo West Campus in Goodyear, AZ. Serafina combines comfort and proximity for an ideal living experience.",
      "page_copy": "Conveniently located near Abrazo West Campus in Goodyear, AZ, Serafina offers a selection of modern apartments that cater to healthcare professionals, patients, and anyone seeking a home close to medical facilities. Our one, two, and three-bedroom options are designed with elegance and functionality, featuring pristine quartz countertops and spacious interiors.\n\nResidents of Serafina enjoy not only the close proximity to essential health services but also access to a variety of onsite amenities that enhance everyday living. Take advantage of our resort-style swimming pool, get active at the fitness center, or relax in our inviting café. Situated within the bustling Canyon Trails neighborhood, Serafina is perfectly placed for access to Goodyear’s vibrant community offerings.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with a waterfall feature and lounge area.",
        "public_id": "019d02cc-a14d-709a-9516-6d20e46ef20c",
        "storage_key": "property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Abrazo West Campus",
      "seo_description": "Discover Serafina's convenient apartments near Abrazo West Campus in Goodyear, AZ. Enjoy luxury living with modern amenities and close healthcare access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "generator",
      "page_item_url": "apartments-close-to-clearsky-rehab-hospital-serafina",
      "search_query": "apartments close to clearsky rehabilitation hospital avondale az",
      "category": "Hospital",
      "h1_title": "Apartments Close to ClearSky Rehabilitation",
      "h2_subtitle": "Discover Serafina, offering apartments close to ClearSky Rehabilitation Hospital in Avondale, AZ. Enjoy comfort and a prime location.",
      "page_copy": "Serafina in Goodyear, AZ, provides the ideal accommodation for those seeking apartments close to ClearSky Rehabilitation Hospital in Avondale. Our community features spacious one, two, and three-bedroom layouts that are perfect for patients, staff, and visitors who require nearby lodging. Each apartment is outfitted with modern, luxurious features like exquisite quartz countertops and generous living spaces.\n\nIn addition to a convenient location, Serafina offers an array of premier amenities designed to enhance your quality of life. Experience relaxation at our resort-style swimming pool, maintain your health in our modern fitness center, or enjoy a cup of coffee in our welcoming café. Located in the vibrant Canyon Trails neighborhood, Serafina is perfectly situated to offer easy access to Avondale, providing residents with the best of both worlds.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with a waterfall feature and lounge area.",
        "public_id": "019d02cc-a14d-709a-9516-6d20e46ef20c",
        "storage_key": "property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to ClearSky Rehabilitation",
      "seo_description": "Find apartments close to ClearSky Rehabilitation Hospital in Avondale, AZ at Serafina, offering luxurious living with top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "generator",
      "page_item_url": "apartments-near-friendship-park-serafina",
      "search_query": "apartments near Friendship Park Goodyear",
      "category": "Park",
      "h1_title": "Apartments Near Friendship Park, Goodyear",
      "h2_subtitle": "Live near Friendship Park in Goodyear, AZ, with Serafina's luxurious apartments. Enjoy nature and top-notch facilities.",
      "page_copy": "Located just minutes from Friendship Park, Serafina in Goodyear, AZ, offers stunning apartments perfect for those who appreciate outdoor recreation and community amenities. Choose from one, two, or three-bedroom units that feature elegant quartz countertops and spacious living areas, making it the ideal sanctuary for residents who value both style and convenience.\n\nEnjoy the freedom of living near one of Goodyear's most popular parks while taking advantage of Serafina's state-of-the-art amenities, including a resort-style swimming pool and a fully equipped fitness center. Nestled in the Canyon Trails neighborhood, our community is perfectly positioned to offer access to local attractions, shopping, and dining, making Serafina an excellent choice for dynamic city living with a touch of nature's tranquility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with a waterfall feature and lounge area.",
        "public_id": "019d02cc-a14d-709a-9516-6d20e46ef20c",
        "storage_key": "property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Friendship Park, Goodyear",
      "seo_description": "Explore Serafina's apartments near Friendship Park in Goodyear, AZ. Enjoy luxurious amenities and easy access to outdoor recreation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "generator",
      "page_item_url": "apartments-close-to-festival-fields-park-serafina",
      "search_query": "apartments close to Festival Fields Park AZ",
      "category": "Park",
      "h1_title": "Apartments Close to Festival Fields Park",
      "h2_subtitle": "Serafina offers luxurious living in Goodyear, AZ, with apartments close to Festival Fields Park. Enjoy proximity to outdoor activities and more!",
      "page_copy": "Discover the ideal blend of comfort and location at Serafina in Goodyear, AZ, offering premier apartments close to Festival Fields Park. Our one, two, and three-bedroom homes come with top-of-the-line features, including chic quartz countertops and expansive layouts, suited for those who love vibrant community living combined with the convenience of nearby recreational spaces.\n\nBeing close to Festival Fields Park means enjoying easy access to a wide range of outdoor activities, from walking trails to sports facilities. At Serafina, you not only benefit from the park's proximity but also the exceptional community amenities like our resort-style swimming pool, modern fitness center, and comforting café environment. Situated in the bustling Canyon Trails neighborhood, Serafina provides seamless access to Goodyear's finest attractions and conveniences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with a waterfall feature and lounge area.",
        "public_id": "019d02cc-a14d-709a-9516-6d20e46ef20c",
        "storage_key": "property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Festival Fields Park",
      "seo_description": "Live at Serafina, with apartments close to Festival Fields Park in Goodyear, AZ. Enjoy luxurious amenities and outdoor adventures year-round.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166451",
      "source": "generator",
      "page_item_url": "apartments-by-alamar-park-canyon-trails-serafina",
      "search_query": "apartments by Alamar Park Canyon Trails",
      "category": "Park",
      "h1_title": "Apartments by Alamar Park, Canyon Trails",
      "h2_subtitle": "Find your home at Serafina, offering chic apartments by Alamar Park in Canyon Trails. Enjoy community living in Goodyear, AZ.",
      "page_copy": "Serafina, located in the vibrant Canyon Trails neighborhood of Goodyear, AZ, offers luxurious apartments conveniently situated by Alamar Park. Our one, two, and three-bedroom residences feature stunning quartz countertops and open-concept designs, providing a perfect retreat for those who enjoy being close to nature and city amenities.\n\nLiving at Serafina means having the serenity of Alamar Park just a short stroll away while also immersing in our community's exquisite amenities. Enjoy a refreshing swim in our resort-style pool, stay active in our state-of-the-art fitness center, or unwind with a cup of coffee at our café. With its strategic location, Serafina offers unparalleled access to the best of Goodyear's outdoor and urban delights.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
      "featured_image_media": {
        "alt_text": "Sparkling swimming pool with a waterfall feature and lounge area.",
        "public_id": "019d02cc-a14d-709a-9516-6d20e46ef20c",
        "storage_key": "property/6767906449166451/019d02cc-a14d-709a-9516-6d20e46ef20c.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Alamar Park, Canyon Trails",
      "seo_description": "Discover Serafina's upscale living with apartments by Alamar Park in Canyon Trails, Goodyear, AZ. Enjoy access to parks and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5323"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425432"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=506a7802c1cf546d24237130026fb6fbac16c323edf752c069c52b0f7562ff70b5c89924f22b82ddf9ea782512da109b\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PM5JF8MT"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "226SRF"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40246265944"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "BR573712000"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Serafina/scheduletourwidget/gDACJnLUbxyhuwT54x/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ijdtb2xaWGJNVFRFSk9lZ1FNYnlIalE9PSIsInZhbHVlIjoiR3d6NUVIZHhMSUtsOTBrc0gwZEF2Zz09IiwibWFjIjoiZWFhN2Q4MTkxMDE4ZGFhZTc2MzgyN2ExOWY2NTE4YmVlYjlmZTQ5NmZjNWQ4MDEyYjQxYjVlYjQwODg4NDczNCJ9"
    }
  ],
  "custom_qb_id": "5323",
  "custom_repli_id": "18104425432",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=506a7802c1cf546d24237130026fb6fbac16c323edf752c069c52b0f7562ff70b5c89924f22b82ddf9ea782512da109b\"></script>",
  "custom_google_gtm_id": "GTM-PM5JF8MT",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "226SRF",
  "custom_hubspot_company_id": "40246265944",
  "custom_broker_license_number": "BR573712000",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Serafina/scheduletourwidget/gDACJnLUbxyhuwT54x/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ijdtb2xaWGJNVFRFSk9lZ1FNYnlIalE9PSIsInZhbHVlIjoiR3d6NUVIZHhMSUtsOTBrc0gwZEF2Zz09IiwibWFjIjoiZWFhN2Q4MTkxMDE4ZGFhZTc2MzgyN2ExOWY2NTE4YmVlYjlmZTQ5NmZjNWQ4MDEyYjQxYjVlYjQwODg4NDczNCJ9",
  "custom_audioeye_site_id": "cfce0dc3-c083-42e0-80d3-d1d29909a253",
  "custom_audioeye_site_hash": "4da4b50a343fe568ae33d02aa7c6a4e3"
};

export const generatedAt = '2026-08-21T22:00:30.157Z';
